import { fetchToken } from '../helpers/fetch';
import { const_routes } from '../helpers/const_routes';
import { types } from '../types/types';
import { startLogout } from './authActions';
import Swal from 'sweetalert2';
import { t } from 'i18next';

const handleAuthErrors = (dispatch, body) => {
  if (!body || body.ok !== false) return false;
  if (body.code === 'bak-aut-tok-inv-001') {
    Swal.fire(t('titles.error'), t('alerts.validation.bak-aut-tok-inv-001'), 'error');
    dispatch(startLogout());
    return true;
  }
  if (body.code === 'bak-aut-tok-inv-002' || body.code === 'bak-aut-tok-001' || body.code === 'bak-aut-tok-002') {
    Swal.fire(t('titles.error'), t('api.token.timed_out'), 'error');
    dispatch(startLogout());
    return true;
  }
  if (body.code === 'bak-error-001') {
    Swal.fire(
      t('titles.error'),
      `${t('alerts.validation.bak-error-001')} - ${body.method || ''}`,
      'error'
    );
    return true;
  }
  return false;
};

const call = async (endpoint, data, method = 'GET') => {
  const resp = await fetchToken(
    `${const_routes.SCHEMA}`,
    `${const_routes.VERSIONV1}`,
    `${const_routes.ROUTE_HOME_CONTENT}`,
    endpoint,
    data,
    method
  );
  return resp.json();
};

export const startLoadingHomeContentTypes = () => {
  return async (dispatch) => {
    dispatch({ type: types.HOME_CONTENT_SET_LOADING, payload: true });
    try {
      const body = await call('types');
      if (body.ok) {
        dispatch({ type: types.HOME_CONTENT_SET_TYPES, payload: body.types || [] });
      } else {
        dispatch({ type: types.HOME_CONTENT_SET_LOADING, payload: false });
        handleAuthErrors(dispatch, body);
      }
      return body;
    } catch (error) {
      dispatch({ type: types.HOME_CONTENT_SET_LOADING, payload: false });
      return { ok: false, msg: String(error) };
    }
  };
};

export const startLoadingHomeContentItems = (filters = {}) => {
  return async (dispatch) => {
    dispatch({ type: types.HOME_CONTENT_SET_LOADING, payload: true });
    try {
      const params = [];
      if (filters.type_key) params.push(`type_key=${encodeURIComponent(filters.type_key)}`);
      if (filters.lang) params.push(`lang=${encodeURIComponent(filters.lang)}`);
      const qs = params.length ? `?${params.join('&')}` : '';
      const body = await call(`get${qs}`);
      if (body.ok) {
        dispatch({ type: types.HOME_CONTENT_SET_ITEMS, payload: body.items || [] });
      } else {
        dispatch({ type: types.HOME_CONTENT_SET_LOADING, payload: false });
        handleAuthErrors(dispatch, body);
      }
      return body;
    } catch (error) {
      dispatch({ type: types.HOME_CONTENT_SET_LOADING, payload: false });
      return { ok: false, msg: String(error) };
    }
  };
};

export const startAddHomeContentItem = (payload) => {
  return async (dispatch) => {
    try {
      const body = await call('add', payload, 'POST');
      if (body.ok) {
        Swal.fire(t('titles.success', { defaultValue: 'Listo' }), t('homeContent.saved'), 'success');
        await dispatch(startLoadingHomeContentItems());
      } else if (!handleAuthErrors(dispatch, body) && body.msg) {
        Swal.fire(t('titles.error'), body.msg, 'error');
      }
      return body;
    } catch (error) {
      Swal.fire(t('titles.error'), String(error), 'error');
      return { ok: false, msg: String(error) };
    }
  };
};

export const startUpdateHomeContentItem = (id, payload) => {
  return async (dispatch) => {
    try {
      const body = await call(`update/${id}`, payload, 'PUT');
      if (body.ok) {
        Swal.fire(t('titles.success', { defaultValue: 'Listo' }), t('homeContent.saved'), 'success');
        await dispatch(startLoadingHomeContentItems());
      } else if (!handleAuthErrors(dispatch, body) && body.msg) {
        Swal.fire(t('titles.error'), body.msg, 'error');
      }
      return body;
    } catch (error) {
      Swal.fire(t('titles.error'), String(error), 'error');
      return { ok: false, msg: String(error) };
    }
  };
};

export const startDeleteHomeContentItem = (id) => {
  return async (dispatch) => {
    try {
      const body = await call(`delete/${id}`, {}, 'DELETE');
      if (body.ok) {
        await dispatch(startLoadingHomeContentItems());
      } else if (!handleAuthErrors(dispatch, body) && body.msg) {
        Swal.fire(t('titles.error'), body.msg, 'error');
      }
      return body;
    } catch (error) {
      return { ok: false, msg: String(error) };
    }
  };
};
